import React, { Component } from "react";
import Folder from "./Folder";
import { Input } from "antd";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import UsersEmails from "./UsersEmails";
import TagsUpload from "./TagsUpload";
import {
  updateFilesList,
  updateRootFolder,
  updateMetadata,
  addFileToSave,
  saveFolderStructure
} from "../../../actions/UploadFolderAction";
import EditIcon from "../../../assets/icons/edit-icon.svg";
import {
  setQtyFilesError,
  handleUserAttemps,
  setNumberAttemps
} from "../../../actions/ClientAction";
import "./UploadFolderStep4.css";
import { RIGHTS_STATUS_ENABLED } from "../../../constants/rights-constants";

class UploadFolderStep4 extends Component {
  handleTags = objectTag => {
    this.props.updateMetadata({
      tags: objectTag.tags
    });
  };

  addUserEmail = email => {
    const { usersEmails } = this.props.uploadFolder;
    const one = usersEmails.find(e => e === email);
    if (one) {
      return;
    }
    usersEmails.push(email);
    this.props.updateMetadata({
      usersEmails: usersEmails
    });
  };

  removeUserEmail = email => {
    const { usersEmails } = this.props.uploadFolder;
    if (email) {
      const newList = usersEmails.filter(e => e !== email);
      this.props.updateMetadata({
        usersEmails: newList
      });
    } else {
      usersEmails.pop();
      this.props.updateMetadata({
        usersEmails: usersEmails
      });
    }
  };

  handleOnEditRoute() {
    this.props.updateMetadata({
      currentStep: 1
    });
  }

  handleOnEditTags() {
    this.props.updateMetadata({
      currentStep: 2
    });
  }

  handleOnEditRights() {
    this.props.updateMetadata({
      currentStep: 2
    });
  }
  handleOnEditUsers() {
    this.props.updateMetadata({
      currentStep: 2
    });
  }
  handleRetry = file => {
    this.props.updateMetadata({
      retryOnlyFile: {
        status: true,
        file: file
      }
    });
  };
  handleAbort = file => {
    this.props.updateMetadata({
      abortOnlyFile: {
        status: true,
        file: file
      }
    });
  };
  handleRemoveFile = file => {
    this.props.updateMetadata({
      removeOnlyFile: {
        status: true,
        file: file
      }
    });
  };
  render() {
    const {
      usersEmails,
      rootFolder,
      route,
      rightsStatus,
      dateToFormatted,
      currentStep,
      fileList
    } = this.props.uploadFolder;

    const { intl, newColor } = this.props;
    const useRightsActive = (this.props.modules || []).some(
      module => module.name === "useRights" && module.activate
    );
    const rightsLabel = rightsStatus === RIGHTS_STATUS_ENABLED
      ? dateToFormatted
        ? intl.formatMessage({ id: "rights_enabled_due" })
        : intl.formatMessage({ id: "rights_enabled_no_due" })
      : intl.formatMessage({ id: "rights_unassigned" });
    return (
      <div
        style={{
          width: "100%",
          height: 450,
          paddingLeft: "5%",
          paddingRight: "5%",
          paddingTop: "1%",
          paddingBottom: "1%",
          overflowY: "auto"
        }}
      >
        <div className="containerUploadFolderStep4">
          <div className="step4_section1">
            <div>
              {rootFolder.map((folder, index) => (
                <Folder
                  key={folder.path}
                  name={folder.name}
                  files={folder.files}
                  path={folder.path}
                  size={folder.size}
                  folderOrFile={folder}
                  readOnly={folder.readOnly}
                  progressVisible={folder.type !== "folder" ? true : undefined}
                  handleAbort={this.handleAbort}
                  handleRemoveFile={this.handleRemoveFile}
                  handleRetry={this.handleRetry}
                  fromStep={currentStep}
                  onDelete={path => {
                    const newList = fileList.filter(e => e.path !== path);
                    this.props.updateFilesList(newList);
                  }}
                  onDeleteFolder={newFolderName => {
                    const newList = fileList.filter(
                      e => !e.path.includes(`${newFolderName}/`)
                    );
                    this.props.updateFilesList(newList);
                  }}
                  onChangeReadOnly={path => {
                    const element = fileList.find(e => e.path === path);
                    if (!element) return;
                    if (element.state && element.state !== "waiting") return;
                    const newList = fileList.map(e => {
                      if (e.path === element.path) {
                        return {
                          ...e,
                          readOnly: false
                        };
                      }
                      return e;
                    });
                    this.props.updateFilesList(newList);
                  }}
                  onChangeReadOnlySelectInput={path => {
                    const element = fileList.find(e => e.path === path);
                    if (!element) return;
                    if (element.state && element.state !== "waiting") return;
                    const newList = fileList.map(e => {
                      if (e.path === element.path) {
                        return {
                          ...e,
                          readOnly: false
                        };
                      }
                      return e;
                    });
                    this.props.updateFilesList(newList);
                  }}
                  onChangeName={(path, newName) => {
                    if (path === newName) return;
                    const element = fileList.find(e => e.path === path);
                    if (!element) return;
                    if (element.state && element.state !== "waiting") return;
                    const newList = fileList.map(e => {
                      if (e.path === element.path) {
                        e.name = newName;
                      }
                      return e;
                    });
                    // this.props.updateRootFolder(newList);
                    this.props.updateFilesList(newList);
                  }}
                />
              ))}
            </div>
          </div>
          <div className="step4_section2">
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center"
              }}
            >
              <p className="step4_tag_title">
                {intl.formatMessage({ id: "upload-folder-step2" })}
              </p>
              <img
                src={EditIcon}
                alt="Edit"
                style={{ cursor: "pointer", marginLeft: 10, color: newColor }}
                onClick={() => this.handleOnEditRoute()}
              />
            </div>
            <Input
              placeholder="/Bunker/.../carpeta2/carpetaActual"
              onChange={e => {}}
              style={{ marginBottom: "10px" }}
              contentEditable={false}
              value={route}
            />
            <div
              style={{
                display: "flex",
                flexDirection: "row"
              }}
            >
              <p className="step4_tag_title">
                {intl.formatMessage({ id: "tags_upload_add_tags" })}
              </p>
              <img
                src={EditIcon}
                alt="Edit"
                style={{ cursor: "pointer", marginLeft: 10 }}
                onClick={() => this.handleOnEditTags()}
              />
              {this.props.uploadFolder.tags.length === 0 && (
                <div className="step4_tag_warning">
                  {intl.formatMessage({ id: "tags_upload_tags_warning" })}
                </div>
              )}
            </div>
            <TagsUpload handleTags={this.handleTags} inputEnabled={false} />
            <div
              style={{
                display: "flex",
                flexDirection: "row"
              }}
            >
              <p className="step4_tag_title">
                {intl.formatMessage({ id: "copyright" })}
              </p>
              <img
                src={EditIcon}
                alt="Edit"
                style={{ cursor: "pointer", marginLeft: 10 }}
                onClick={() => this.handleOnEditRights()}
              />
            </div>
            {useRightsActive && (
              <div className="step4_usage">
                {rightsLabel}
                {dateToFormatted && ` · ${dateToFormatted}`}
              </div>
            )}
            <div
              style={{
                display: "flex",
                flexDirection: "row"
              }}
            >
              <p className="step4_tag_title">
                {intl.formatMessage({ id: "upload-folder-s4-notify" })}
              </p>
              <img
                src={EditIcon}
                alt="Edit"
                style={{ cursor: "pointer", marginLeft: 10 }}
                onClick={() => this.handleOnEditUsers()}
              />
            </div>

            <UsersEmails
              usersEmails={usersEmails}
              onRemove={e => {
                this.removeUserEmail(e);
              }}
              onAdd={this.addUserEmail}
              inputEnabled={false}
            />
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = state => {
  return {
    user: state.authUser.user,
    clientId: state.client.data ? state.client.data._id : null,
    clientName: state.client.data ? state.client.data.name : "",
    uploadFolder: state.uploadFolder,
    fileListToSave: state.uploadFolder.fileListToSave,
    fileList: state.uploadFolder.fileList,
    qtyFilesError: state.client.qtyFilesError,
    attemps: state.client.attemps,
    numberAttemps: state.client.numberAttemps,
    isUploading: state.client.isUploading,
    workclient: state.client.workclient,
    newColor:
      state.authUser.user && state.authUser.user.color
        ? state.authUser.user.color
        : "#2E97CF",
    modules: state.client.data ? state.client.data.modules : []
  };
};

const mapDispatchToProps = {
  updateMetadata,
  updateFilesList,
  updateRootFolder,
  setQtyFilesError,
  handleUserAttemps,
  setNumberAttemps,
  addFileToSave,
  saveFolderStructure
};

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(UploadFolderStep4))
);
